// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"xU-z","inlineTitle":"yU-z","sponsoredAdsWrapper":"zU-z","marketplaceRecosWrapper":"AU-z"};